<script lang="ts" setup>
  import type { TypeYouTubeComponent } from '~/types/contentful'

  defineProps<{
    data: TypeYouTubeComponent<'WITHOUT_UNRESOLVABLE_LINKS', string>
  }>()
</script>

<template>
  <section class="m-youtube">
    <!-- eslint-disable-next-line vuejs-accessibility/iframe-has-title -->
    <iframe
      :src="`https://www.youtube.com/embed/${data.fields.videoId}?autoplay=0`"
      class="module-paddings"
      frameborder="0"
      height="720px"
      type="text/html"
      width="1280px"
    />
  </section>
</template>

<style lang="scss" scoped>
  .m-youtube {
    width: 100%;
    background-color: v-bind('data.fields.base?.fields.backgroundColour');
  }

  iframe {
    width: 100%;
    max-height: 560px;
  }
</style>
